import { tenLogMean, tenLogSum } from 'app/shared/aggregators';
import { IMSAggregator } from './aggregator';

/**
 * @ngdoc service
 * @name ims.viewControllers.service:TenLogMeanAggregator
 * @description
 * The TenLogMeanAggregator is a service that calculates the 10 log mean an array of stats or values.
 * It's relevant for averaging noise values measured in decibels
 */

export class TenLogMeanAggregator extends IMSAggregator {
    constructor() {
        super();
        this.logicalName = 'tenLogMean';
        this.displayName = '10 Log (mean)';
    }

    /**
     * Takes in an array of values and returns an aggregate value.
     * Averages (mean) the valueArray.
     *
     * @param valueArray An array of values
     * @returns Number number or string value
     */
    getAggValueForValueArray(valueArray: number[]): undefined | number {
        const value = tenLogMean(valueArray);

        return value !== undefined ? value : null;
    }
}

/**
 * @ngdoc service
 * @name ims.viewControllers.service:TenLogSumAggregator
 * @description
 * The TenLogSumAggregator is a service that calculates the 10 log Sum an array of stats or values.
 * It's relevant for averaging noise values measured in decibels
 */

export class TenLogSumAggregator extends IMSAggregator {
    constructor() {
        super();
        this.logicalName = 'tenLogSum';
        this.displayName = '10 Log (sum)';
    }

    /**
     * Takes in an array of values and returns an aggregate value.
     * Averages (Sum) the valueArray.
     *
     * @param valueArray An array of values
     * @returns Number number or string value
     */
    getAggValueForValueArray(valueArray: number[]): undefined | number {
        const value = tenLogSum(valueArray);

        return value !== undefined ? value : null;
    }
}
